export function isNilOrEmpty(value) {
  return value === undefined || value === null || value === "";
}


export  function timeout(delay) {
  return new Promise( res => setTimeout(res, delay) );
}